export enum ApiUrls {
	//calculation
	RUN_CALCULATION_PREDEFINED = 'Calculation/job/{jobId}/start-predefined',
	RUN_CALCULATION_WITH_SETTINGS = 'Calculation/job/{jobId}/start-custom',
	RUN_CALCULATION_MOST_RECENT = 'Calculation/job/{jobId}/most-recent',
	GET_RECENT_CALCULATIONS = 'Calculation/job/{jobId}/recent-runs/{take}',
	GET_CALCULATION_SETTINGS_ANALYSIS_GROUPS = 'calculationSettings/analysisGroups',
	FETCH_ROLLOVER_COUNT_FROM_SETTINGS = 'Calculation/job/{jobId}/last-successful-calculation-details',
	CANCEL_CALCULATION = 'Calculation/job/{jobId}/{calculationId}/cancel',
	REFRESH_CALCULATION_STATUS = 'calculation-step/{calculationId}/refresh-status',
	
	//Dashboard
	GET_DASHBOARD_SUMMARY = 'Dashboard/job/{jobId}/summary/{calculationProcessId}',
	GET_PIE_CHARTS_DATA = 'charts/job/{jobId}/pie-chart',
	GET_BAR_CHARTS_DATA = 'charts/job/{jobId}/bar-chart',
	GET_DRILLDOWN_CHARTS_DATA = 'charts/job/{jobId}/drillDown-chart',
	GET_BOOKTAXABLE_CHARTS_DATA = 'charts/job/{jobId}/booktaxable-chart',

	//report
	GET_OUTPUT_REPORT_CONTENT = 'report/{jobId}/{type}',
	DOWNLOAD_REPORT = 'job/{jobId}/calculation/{calculationId}/report',
	DOWNLOAD_ERROR = 'job/{jobId}/calculation/{calculationId}/error',
	DOWNLOAD_REPORTS = 'report/client/{clientId}/job/{jobId}/import/{importId}/download',
	DOWNLOAD_AUTOREVIEW_REPORT = 'autoreview/job/{jobId}/calculation/{calculationId}/report',
	DOWNLOAD_ENORMOUS_ZIP_FILE = 'EnormousFileUploads/{jobId}/{importId}/download-zip-file',


	//Reference Table
	GET_CLIENT_REFERENCE_LIBRARY = 'client/{clientId}/client-reference/job/{jobId}',
	UPLOAD_REFERENCE_FILE = 'client/{clientId}/client-reference/job/{jobId}',
	DOWNLOAD_REFERENCE_FILE = 'client/{clientId}/client-reference/{id}/file-download/{type}/{jobId}',
	UPDATE_REFERENCE_FILE = 'client/{clientId}/client-reference/{id}/update/job/{jobId}',
	GET_RSM_REFERENCE_LIBRARY = 'rsm-standard-reference',
	RSM_REFERENCE_LIBRARY = 'rsm-standard-reference',
	DOWNLOAD_RSM_REFERENCE_FILE = 'rsm-standard-reference/{id}/download',
	CHECK_CONNECTED_JOBS_FOR_CLIENT_REFERENCE_TABLES = 'client/{clientId}/client-reference/{id}/connected-jobs/job/{jobId}',

	//Ruleset
	GET_CLIENT_RULESET = 'ruleset/client/{clientId}/job/{jobId}',
	GET_RSM_RULESET = 'ruleset',
	UPLOAD_CLIENT_RULESET = 'ruleset/client-upload/{clientId}/{jobId}',
	UPLOAD_RSM_RULESET = 'ruleset/upload',
	UPDATE_CLIENT_RULESET = 'ruleset/client/{clientId}/update-metadata/{jobId}',
	UPDATE_RSM_RULESET = 'ruleset/update-metadata',
	CHECK_CONNECTED_JOBS_FOR_RULESET = 'ruleset/{rulesetId}/connected-jobs',

	//Asset warehouse
	GET_CLIENT_ASSETWAREHOUSE = 'asset-warehouse/client/{clientId}/job/{jobId}',
	GET_RSM_ASSETWAREHOUSE = 'asset-warehouse',
	UPLOAD_CLIENT_ASSETWAREHOUSE = 'asset-warehouse/client-upload/{jobId}',
	UPLOAD_RSM_ASSETWAREHOUSE = 'asset-warehouse/upload',
	UPDATE_CLIENT_ASSETWAREHOUSE = 'asset-warehouse/client/{clientId}/update-metadata/job/{jobId}',
	UPDATE_RSM_ASSETWAREHOUSE = 'asset-warehouse/update-metadata',
	DOWNLOAD_RSM_ASSETWAREHOUSE_FILE = 'asset-warehouse/{id}/download',

	//Dividend Table
	GET_CLIENT_DIVIDEND_WAREHOUSE = 'dividend-warehouse/client/{clientId}/job/{jobId}',
	GET_RSM_DIVIDEND_WAREHOUSE = 'dividend-warehouse',
	UPLOAD_CLIENT_DIVIDEND_WAREHOUSE = 'dividend-warehouse/client-upload/{clientId}/job/{jobId}',
	UPLOAD_RSM_DIVIDEND_WAREHOUSE = 'dividend-warehouse/upload',
	DOWNLOAD_DIVIDEND_WAREHOUSE = 'file-download/{fileUploadId}',
	UPDATE_CLIENT_DIVIDEND_WAREHOUSE = 'dividend-warehouse/client/{clientId}/update-metadata/job/{jobId}',
	UPDATE_RSM_DIVIDEND_WAREHOUSE = 'dividend-warehouse/update-metadata',
	DOWNLOAD_RSM_DIVIDEND_WAREHOUSE_FILE = 'dividend-warehouse/{id}/download',

	//Inputs
	GET_DATASET_INPUT_JSON = 'job/{jobId}/dataset/{datasetId}/input/{type}',
	GET_LIBRARY_INPUT_JSON = 'Inputs/{jobId}/{id}/type/{type}',
	GET_CALCULATION_INPUT = 'Dataset/job/{jobId}/{importId}',
	GET_ENORMOUS_UPLOAD_DETAILS = 'EnormousFileUploads/get-all-enormous-uploads',
	UPLOAD_ENORMOUS_ETL_DATA = 'EnormousFileUploads/{jobId}/upload-etl-data',

	//Usage Statistics
	GET_IMPORT_STATISTICS = 'importStatistics/{startDate}/{endDate}',
	GET_CALCULATION_STATISTICS = 'calculationStatistics/{startDate}/{endDate}',

	//Job
	BASE_JOB_URL = 'job/{jobId}/',
	CREATE_STATUS_DETAIL = 'detail/job/{jobId}/create',
	GET_STATUS_DETAIL = 'detail/job/{jobId}/most-recent',
	CREATE_EVENT = 'event/job/{jobId}/type/{eventType}',
	GET_EVENTS = 'event/job/{jobId}',
	GET_FAVORITE_JOBS = 'favoriteJobs',
	CREATE_FAVORITE_JOBS = 'favoriteJobs/job/{jobId}',
	REMOVE_FAVORITE_JOBS = 'favoriteJobs/job/{jobId}',
	FETCH_USER_LIST_FOR_JOB = 'routeto/{jobId}/users',

	//Template
	DOWNLOAD_OR_UPLOAD_LATEST_TEMPLATE = 'template',
	FETCH_TEMPLATE_HISTORY = 'template/history',
	EDIT_TEMPLATE_DETAILS = 'template/{templateId}',
	DOWNLOAD_TEMPLATE = 'template/{templateId}',
	DOWNLOAD_EMPTY_TEMPLATE = 'template/job/{jobId}',
	DOWNLOAD_ACTIVE_TEMPLATE = 'job/{jobId}/dataset/{datasetId}',

	//Pricing
	GET_VOLUME_MULTIPLIER = 'volumemultiplier',
	CREATE_VOLUME_MULTIPLIER = 'volumemultiplier/create',
	UPDATE_VOLUME_MULTIPLIER = 'volumemultiplier/{id}/update',
	DELETE_VOLUME_MULTIPLIER = 'volumemultiplier/{id}/delete',

	GET_CALCULATION_SETTINGS_FACTOR = 'calculationsettingsfactor',
	CREATE_CALCULATION_SETTINGS_FACTOR = 'calculationsettingsfactor/create',
	UPDATE_CALCULATION_SETTINGS_FACTOR = 'calculationsettingsfactor/{id}/update',
	DELETE_CALCULATION_SETTINGS_FACTOR = 'calculationsettingsfactor/{id}/delete',

	CREATE_CALCULATION_SUB_SETTINGS_FACTOR = 'calculationsubsettingsfactor/create',
	GET_CALCULATION_SUB_SETTINGS_FACTOR = 'calculationsubsettingsfactor',
	UPDATE_CALCULATION_SUB_SETTINGS_FACTOR = 'calculationsubsettingsfactor/{id}/update',
	DELETE_CALCULATION_SUB_SETTINGS_FACTOR = 'calculationsubsettingsfactor/{id}/delete',

	CREATE_PRICING_OVERRIDE = 'pricingoverride/create',
	UPDATE_PRICING_OVERRIDE = 'pricingoverride/{id}/update',
	GET_PRICING_OVERRIDE = 'pricingoverride',
	DELETE_PRICING_OVERRIDE = 'pricingoverride/{id}/delete',

	GET_PRICING = 'pricing/',
	CREATE_PRICING = 'pricing/create',
	UPDATE_PRICING = 'pricing/{id}/update',
	DELETE_PRICING = 'pricing/{id}/delete',

	//File Download
	DOWNLOAD_FILE_FROM_JOB = 'file-download/job/{jobId}/{fileId}',
	DOWNLOAD_FILE = 'file-download/{fileId}',

	//Notification
	GET_NOTIFICATIONS = 'persistent/get-notification',
	GET_NOTIFICATIONS_BY_JOBID = 'persistent/get-notification/{jobId}',
	GET_NOTIFICATIONS_BY_EVENT = 'persistent/get-notification-by-event/{eventGroup}',

	//Billing
	Billing = 'billing',

	//ScheduledRetrievals
	SCHEDULED_RETRIEVALS = 'ScheduledRetrievals',
	GET_SCHEDULED_RETRIEVAL_DETAILS = 'ScheduledRetrievals/{id}',
	UPDATE_SCHEDULED_RETRIEVAL_DETAILS = 'ScheduledRetrievals/{id}/update',

	//Auto Regression
	FETCH_ALL_TESTCASES = 'SanityCheck/fetch-all-testcases',
	RUN_TEST_CASE = 'Job/{id}/upload-test-data',
	UPLOAD_INPUTOUTPUT_FILES = 'TestCase/update-import-file',
	FETCH_CALCULATION_PROCESS_ID = 'TestCase/{testCaseId}/calculation-process/fetch',
	RESET_TESTCASE = 'TestCase/{testCaseId}/reset',
	UPDATE_TESTCASE_STATUS_USING_TESTCASEID = 'TestCase/update-execution-details',
	DOWNLOAD_IMPORTED_DATASET_USING_TESTCASEID = 'TestCase/{testCaseId}/input-and-gc-files/download',
	DOWNLOAD_REGRESSION_FILES = 'FileComparison/calculation/{calculationId}/download',
	DOWNLOAD_REGRESSION_ERROR_FILE = 'FileComparison/calculation/{calculationId}/download/exception'
}